export enum ProductionScheduleStatusColorDescription {
  BUSY = 'BUSY',
  COMPLETE = 'COMPLETE',
  FAILURE = 'FAILURE',
  WARNING = 'WARNING'
}
